import { convert } from 'html-to-text';

export const htmlToText = (html: string) => {
  return convert(html, {
    wordwrap: false,
    selectors: [
      { selector: 'h1', options: { uppercase: false } },
      { selector: 'h2', options: { uppercase: false } },
      { selector: 'h3', options: { uppercase: false } },
      { selector: 'h4', options: { uppercase: false } },
      { selector: 'table', options: { uppercaseHeaderCells: false } },
      { selector: 'strong', format: 'keepHtml' },
      { selector: 'b', format: 'keepHtml' },
      { selector: 'i', format: 'keepHtml' },
      { selector: 'a', options: { ignoreHref: true } },
      { selector: 'img', format: 'skip' }
    ],
    formatters: {
      keepHtml: (elem, walk, builder) => {
        builder.addInline(`<${elem.name}>`);
        walk(elem.children, builder);
        builder.addInline(`</${elem.name}>`);
      }
    }
  });
};
